import React from 'react';
import styled from 'styled-components';

import { Theme } from 'shared/theme';
import { useAppContext } from 'shared/context';
import { ButtonSnapPosition } from 'components';
import { Map, DevOverlay } from 'containers';

export default function Main(): JSX.Element {
  const { theme } = useAppContext();

  return (
    <MainWrapper theme={theme}>
      <ButtonSnapPosition />
      <Map />
      <DevOverlay />
    </MainWrapper>
  );
}

const MainWrapper = styled.div.attrs(({ theme }: { theme: Theme }) => {
  const style: React.CSSProperties = {
    color: theme.primaryText,
    backgroundColor: theme.primaryBg,
  };
  return { style };
})<{ theme: Theme }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
`;
